import './footer.css';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FeedbackIcon from '@mui/icons-material/Feedback';

export default function Footer() {
    return (
        <footer className='footer'>
            <div className='footer-content'>
                <div className='footer-section footer-about'>
                    <h3>Valheim Cooking</h3>
                    <p>Your ultimate companion for mastering the culinary arts in Valheim.</p>
                    <p className='footer-tagline'>Made with <FavoriteIcon className='heart-icon' /> by <span className='bug-busters-green'>Bug Busters</span></p>
                </div>
                
                <div className='footer-section footer-links'>
                    <h4>Quick Links</h4>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/food-table">Food Table</a></li>
                        <li><a href="/cooking-stations">Cooking Stations</a></li>
                        <li><a href="/settings">Filters</a></li>
                    </ul>
                </div>
                
                <div className='footer-section footer-support'>
                    <h4>Support Us</h4>
                    <p>If you find this tool helpful, consider supporting our work!</p>
                    <a href="https://www.buymeacoffee.com/countdisoQ" target="_blank" rel="noopener noreferrer" className='coffee-link'>
                        <img 
                            src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" 
                            alt="Buy Me A Coffee" 
                            className='coffee-button'
                        />
                    </a>
                </div>
                
                <div className='footer-section footer-social'>
                    <h4>Connect</h4>
                    <div className='social-links'>
                        <a href="https://feedback.waynerockett.com/valheim-cooking" target="_blank" rel="noopener noreferrer" className='social-icon' aria-label="Feedback">
                            <FeedbackIcon />
                        </a>
                    </div>
                </div>
            </div>
            
            <div className='footer-bottom'>
                <p>&copy; {new Date().getFullYear()} Bug Busters. All rights reserved.</p>
            </div>
        </footer>
    );
}

